module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9c2e8fc66ddf257858ee277af88a7e45.png";